/**
 * @generated SignedSource<<fc8305fdf5209e2adc6247847e2cf39d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion$data = {
  readonly canAddAndRemoveIssues: boolean | null | undefined;
  readonly id: string;
  readonly issuesForList: {
    readonly edges: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges" | "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference">;
    } | null | undefined>;
    readonly totalCount: number | null | undefined;
  };
  readonly " $fragmentSpreads": FragmentRefs<"issueTotalCount_softwareReleasesVersionDetailIssueList" | "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion" | "listOptions_softwareReleasesVersionDetailIssueList" | "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion" | "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection" | "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion">;
  readonly " $fragmentType": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion";
};
export type ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "filters"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "sortBy"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": [
          "issuesForList"
        ]
      }
    ]
  },
  "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionDetailIssueList_IssuesRefetchable_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "listOptions_softwareReleasesVersionDetailIssueList"
    },
    {
      "kind": "FragmentSpread",
      "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraVersion"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueTotalCount_softwareReleasesVersionDetailIssueList"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesCollapsibleUiToggle_CollapsibleSection"
    },
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesAddIssuesToVersion_AddIssuesToVersion"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "canAddAndRemoveIssues"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": "issuesForList",
        "args": [
          {
            "kind": "Literal",
            "name": "filter",
            "value": "ALL"
          },
          {
            "kind": "Variable",
            "name": "filters",
            "variableName": "filters"
          },
          {
            "kind": "Variable",
            "name": "sortBy",
            "variableName": "sortBy"
          }
        ],
        "concreteType": "JiraIssueConnection",
        "kind": "LinkedField",
        "name": "__ListVersion_issuesForList_connection",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraIssueEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "issues_softwareReleasesVersionDetailIssueList_jiraIssueEdgesReference"
                },
                {
                  "kind": "FragmentSpread",
                  "name": "issuesMoreButton_softwareReleasesVersionDetailIssueList_jiraIssueEdges"
                },
                {
                  "kind": "ScalarField",
                  "name": "cursor"
                },
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "__typename"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "issuesForList.edges"
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      "action": "THROW",
      "path": "issuesForList"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "1b95186d8ae0c639ac2a3313467b4212";

export default node;
